export function getInitials(name: string | undefined) {
  const trimmedName = name?.trim();

  // Если после trim пустая строка или нет букв (только цифры/символы), считаем, что имени нет
  if (!trimmedName || !hasAnyLetter(trimmedName)) {
    return;
  }

  const words = trimmedName.split(/\s+/).filter(Boolean);

  if (!words.length) {
    return;
  }

  const initials: string[] = [];

  // Если одно слово - показываем только первую букву
  if (words.length === 1) {
    const firstLetter = getFirstLetter(words[0]);
    if (firstLetter) {
      initials.push(firstLetter);
    }
  } else {
    // Если два и более слов - показываем первые буквы двух первых слов
    for (let i = 0; i < Math.min(words.length, 2); i++) {
      const firstLetter = getFirstLetter(words[i]);
      if (firstLetter) {
        initials.push(firstLetter);
      }
    }
  }

  return initials.length > 0 ? initials.join('') : undefined;
}

/**
 * Извлекает первую букву из слова (любого языка)
 */
function getFirstLetter(word: string): string | null {
  for (const char of word) {
    // Проверяем, является ли символ буквой любого языка (Unicode Letter)
    if (/\p{L}/u.test(char)) {
      return char.toUpperCase();
    }
  }
  return null;
}

/**
 * Проверяет, содержит ли строка хотя бы одну букву (любого языка)
 */
function hasAnyLetter(str: string): boolean {
  return /\p{L}/u.test(str);
}
